<template>
  <div class="bolusCalculatorSettingTable_ctn" :style="style" :class="{ isLongLanguage }">
    <div class="bolusCalculatorSettingTable--twoColumn bolusCalculatorSettingTable_descriptionRow bolusCalculatorSettingTable_titleRow--top roundedCorner-t-l roundedCorner-t-r">      
      <div class="bolusCalculatorSettingTable_descriptionRow--label"> {{ $t('Active Insulin Time') }}</div>
      <div class="bolusCalculatorSettingTable_descriptionRow--content">{{ extra.effectiveTime }}</div>
    </div>
    <div class="bolusCalculatorSettingTable--twoColumn bolusCalculatorSettingTable_descriptionRow roundedCorner-b-l roundedCorner-b-r">      
      <div class="bolusCalculatorSettingTable_descriptionRow--label"> {{ $t('Reverse Correction') }}</div>
      <div class="bolusCalculatorSettingTable_descriptionRow--content">{{ extra.reverseCorrection !== undefined ? ($t((extra.reverseCorrection ? 'YES' : 'NO'))) : '' }}</div>
    </div>
    <div class="bolusCalculatorSettingTable-24ctn">
      <div class="bolusCalculatorSettingTable-24ctn_oneVerticalCtn">
        <div class="bolusCalculatorSettingTable-24ctn_oneVerticalCtn--title"> {{ $t('Carbohydrate Ratio') }}</div>
        <div class="bolusCalculatorSettingTable-24ctn_oneVerticalCtn--content">
          <div v-for="v in 24" :key="`bolusCalculator_cr_row_${v}`" class="bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow" :class="{'bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--first': +v === 1, 'bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--last': +v === 24}">
            <div class="bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--label">{{ carboList24ed[v - 1] ? carboList24ed[v - 1].column0 : '' }}</div>
            <div class="bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--ctn">{{ carboList24ed[v - 1] ? carboList24ed[v - 1].column1 : '' }}<span class="ctn-unit">{{ carboList24ed[v - 1] ? carboList24ed[v - 1].unitStr : '' }}</span></div>
          </div>
        </div>
      </div>
      <div class="bolusCalculatorSettingTable-24ctn_oneVerticalCtn">
        <div class="bolusCalculatorSettingTable-24ctn_oneVerticalCtn--title"> {{ $t('Insulin Sensitivity') }}</div>
        <div class="bolusCalculatorSettingTable-24ctn_oneVerticalCtn--content">
          <div v-for="v in 24" :key="`bolusCalculator_is_row_${v}`" class="bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow" :class="{'bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--first': +v === 1, 'bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--last': +v === 24}">
            <div class="bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--label">{{ sensitivityList24ed[v - 1] ? sensitivityList24ed[v - 1].column0 : '' }}</div>
            <div class="bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--ctn">{{ sensitivityList24ed[v - 1] ? sensitivityList24ed[v - 1].column1 : '' }}<span class="ctn-unit">{{ sensitivityList24ed[v - 1] ? sensitivityList24ed[v - 1].unitStr : '' }}</span></div>
          </div>
        </div>
      </div>
      <div class="bolusCalculatorSettingTable-24ctn_oneVerticalCtn bolusCalculatorSettingTable-24ctn_oneVerticalCtn--wider">
        <!-- <div class="bolusCalculatorSettingTable-24ctn_oneVerticalCtn--title"> {{ $t('Target BG Value') }}{{ targetBgValueUnit ? ` [${targetBgValueUnit}]` : '' }}</div> -->
        <div class="bolusCalculatorSettingTable-24ctn_oneVerticalCtn--title"> {{ $t('Target BG Value') }}</div>
        <div class="bolusCalculatorSettingTable-24ctn_oneVerticalCtn--content">
          <div v-for="v in 24" :key="`bolusCalculator_tbv_row_${v}`" class="bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow" :class="{'bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--first': +v === 1, 'bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--last': +v === 24}">
            <div class="bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--label">{{ bgList24ed[v - 1] ? bgList24ed[v - 1].column0 : '' }}</div>
            <div class="bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--ctn"><div>{{ bgList24ed[v - 1] ? bgList24ed[v - 1].column1 : '' }}<span class="ctn-unit">{{ bgList24ed[v - 1] ? bgList24ed[v - 1].unitStr : '' }}</span></div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reDrawTrigger from '@mx/reDrawTrigger'
import dayjs from 'dayjs'
import { derrorFactory, errorFactory } from '@u/log'
import { _getMergedPumpBigDosageFromRecords } from '@u/reportHelper'
const derror = derrorFactory('BolusCalculatorSettingTable.vue', false)
const error = errorFactory('BolusCalculatorSettingTable.vue', true)

function _to24ed(list = []) {
  // console.error(`_to24ed, list`, list)
  const rst = []
  
  for (let i = 0; i < 24; i++) {
    const data = list[i]
    const hasData = !!data
    
    if (hasData) {
      const isBg = data.column1 && !/^[0-9\.]+$/i.test(data.column1)
      
      // 插入真实数据
      if (!isBg) {
        rst.push({
          isBg,
          column0: data.column0,
          column1: data.column1,
          unitStr: data.unitStr
        }) 
      } else {
        const str = data.column1
        const twoStr = str.replaceAll(/[^\.0-9;]/g, '')
        const two = twoStr.split(';')
        rst.push({
          isBg,
          column0: data.column0,
          column1: `${two[0]}-${two[1]}`,
          unitStr: data.unitStr
        }) 
      }     
    } else {
      // 推入empty数据
      rst.push({
        column0: '',
        column1: '',
        unitStr: ''
      })
    }
  }

  // console.error(`_to24ed, 处理后list`, rst)
  return rst
}

let _id = 1
export default {
  name: 'CBolusCalculatorSettingTableV2',
  components: {
  },
  mixins: [reDrawTrigger],
  props: {
    extra: {
      type: [Object],
      default: () => {
        return {}
      }
    },
    carboList: {
      type: [Array],
      default: () => []
    },
    carboRowNums: { // 总共可展现数据对: carboRowNums * 2 条
      type: [Number],
      default: 0
    },
    bgRowNums: {
      type: [Number],
      default: 0
    },
    bgList: {
      type: [Array],
      default: () => []
    },
    sensitivityList: {
      type: [Array],
      default: () => []
    },
    sensitivityRowNums: { // 总共可展现数据对: sensitivityRowNums * 2 条
      type: [Number],
      default: 0
    },
    showMarginRight: {
      type: [Number, Boolean, String],
      default: true
    },
    showHeader: {
      type: [Number, Boolean, String],
      default: false
    }
  },
  data() {
    _id++
    const id = `pump2columnstable_${+new Date()}_${_id}`
    
    return {
      id,
    }
  },
  computed: {
    carboList24ed() {
      const list = this.carboList || []
      derror(`carboList原始:`, list)
      return _to24ed(list).filter(obj => {
        const { column1 = '' } = obj
        let stay = true
        stay = String(column1) !== '0' // 0的值，意味着没有设置
        return stay
      })
    },
    sensitivityList24ed() {
      const list = this.sensitivityList || []
      derror(`sensitivityList原始:`, list)
      return _to24ed(list).filter(obj => {
        const { column1 = '' } = obj
        let stay = true
        stay = String(column1) !== '0' // 0的值，意味着没有设置
        return stay
      })
    },
    bgList24ed() {
      const list = this.bgList || []
      derror(`bgList原始:`, list)
      const rst = _to24ed(list).filter(obj => {
        const { column1 = '' } = obj
        let stay = true
        if (/-/.test(String(column1))) {
          const twos = String(column1).split('-')
          if (twos && twos[0] && +twos[0] === '0') { //  0的值，意味着没有设置
            stay = false
          }
        }
        return stay
      })

      return rst
    },
    w() {      
      const { ds } = this

      // return ds * (560 / 1740)
      return ds * (660 / 1740)
      // return ds * (760 / 1740)
      // return ds * (1140 / 1740) // 这个才对得起3列。750是2列。但是3列的话右侧放不下了
      // return ds * (1160 / 1740)
    },
    style() {
      const { showMarginRight, zoomRatio, w } = this
      const rst = { zoom: zoomRatio, width: `${w}px` }
      
      if (`${showMarginRight}`.toLowerCase().trim() !== `false` && showMarginRight) {
        rst.marginRight = Math.floor(zoomRatio * 20) + 'px'
      }
      return rst
    },
    targetBgValueUnit() {
      const { isPolishLanguage, bgList = [] } = this
      if (isPolishLanguage) {
        return ''
      }
      if (bgList && bgList[0] && bgList[0]['unitStr']) {
        return bgList[0]['unitStr']
      } else {
        return ''
      }
    },
    carbohydrateRatioUnit() {
      const { isPolishLanguage, carboList = [] } = this
      if (isPolishLanguage) {
        return ''
      }
      if (carboList && carboList[0] && carboList[0]['unitStr']) {
        return carboList[0]['unitStr']
      } else {
        return ''
      }
    },
    sensitivityUnit() {
      const { isPolishLanguage, sensitivityList = [] } = this
      if (isPolishLanguage) {
        return ''
      }
      if (sensitivityList && sensitivityList[0] && sensitivityList[0]['unitStr']) {
        return sensitivityList[0]['unitStr']
      } else {
        return ''
      }
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/mixin';
@import '@/styles/variables';

$rowH: 40px;
.bolusCalculatorSettingTable_ctn {
    color: $colorGluMesurementFont;
    font-weight: 600;
    font-size: $sizeFontSize;
    display: inline-block;
    @include bBox;
    .bolusCalculatorSettingTable_titleRow {
        @include bBox;
        height: $rowH;
        /* @include heightMiddle($rowH); */
        @include flexRow(flex-start, center);
        .highLowTable-titleRow_content {
            @include bBox;
            width: 40%;
            flex-shrink: 1;
            text-align: center;
        }
    }
    .bolusCalculatorSettingTable_border--right {
        border-right: 1px solid $colorGluMesurementInnerBorder;
    }
    .bolusCalculatorSettingTable_titleRow, .bolusCalculatorSettingTable_descriptionRow {
        @include bBox;
        /* @include heightMiddle($rowH); */
        height: $rowH;
        overflow: hidden;
        min-height: $rowH;
        border: 1px solid $colorGluMesurementInnerBorder;
        border-top-width: 0;
        /* border-bottom-width: 0; */
        text-indent: 7px;
        &.bolusCalculatorSettingTable_titleRow--last {
            border-bottom: 1px solid $colorGluMesurementInnerBorder;
        }
        &.bolusCalculatorSettingTable_titleRow--top {
            /* text-indent: 20px; */
            border-top-width: 1px;
            /* border-bottom-width: 1px; */
        }
    }
    .bolusCalculatorSettingTable_descriptionRow {
        @include flexRow;
        width: (2 / 3) * 100%;
        .bolusCalculatorSettingTable_descriptionRow--label, .bolusCalculatorSettingTable_descriptionRow--content {
            @include bBox;
            flex-grow: 1;
            flex-shrink: 1;
            height: 100%;
            min-height: $rowH;
            width: 25%;
            @include flexColumn(center, center)
        }
        .bolusCalculatorSettingTable_descriptionRow--content {
            font-weight: normal;
        }
        &.bolusCalculatorSettingTable--twoColumn {
            .bolusCalculatorSettingTable_descriptionRow--label {
                width: 20%;
                width: 40%;
                flex-grow: 0;
                flex-shrink: 0;
            }
            .bolusCalculatorSettingTable_descriptionRow--content {
                width: 70%;
                flex-grow: 1;
                flex-shrin: 1;
            }
        }
        .bolusCalculatorSettingTable_descriptionRow--label {
            background-color: $colorGluMesurementLabelBg;
            color: $colorGluMesurementFont;
            padding: 0 5px;
            text-indent: 0;
            
            &.bolusCalculatorSettingTable_descriptionRow--label2 {
                width: 25%;
                flex-grow: 0;
                font-size: 0.92em;
            }
            &.bolusCalculatorSettingTable_descriptionRow--label3 {
                width: calc(263 / 455) * 100%;
                flex-grow: 0;
                font-size: 1em;
            }
        }
        
        &.bolusCalculatorSettingTable_descriptionRow--columns {
            align-items: stretch;
            height: auto;
            .bolusCalculatorSettingTable_descriptionRow--columnsOneColumn {
                width: 49%;
                flex-grow: 1;
                @include bBox;
                &.bolusCalculatorSettingTable_descriptionRow--rows {
                    @include flexRow(space-between, stretch);
                    .bolusCalculatorSettingTable_descriptionRow--rowsTitle {
                        background-color: $colorGluMesurementLabelBg;
                        width: 40%;
                        width: 40%;
                        flex-grow: 0;
                        flex-shrink: 0;
                        @include flexRow(space-around, center);
                    }
                    .bolusCalculatorSettingTable_descriptionRow--rowsCtn {
                        flex-grow: 1;
                        .bolusCalculatorSettingTable_descriptionRow--rowsCtnOneRow {
                            border-bottom: 1px solid $colorGluMesurementInnerBorder;
                            &:last-child {
                                border-bottom: 0;
                            }
                            height: $rowH;
                            @include bBox;
                            @include flexRow(space-around, center);
                            > div {
                                /* background: red; */
                                flex-grow: 0;
                                &:first-child {
                                    width: calc(100em / 12);
                                }
                                &:last-child {
                                    /* background: blue; */
                                    flex-grow: 1;
                                    text-align: right;
                                    padding-right: 6px;
                                }
                            }
                        }
                    }
                }   
            }
        }
    }
    
    &.isLongLanguage {
        .bolusCalculatorSettingTable_descriptionRow {
            .bolusCalculatorSettingTable_descriptionRow--columnsOneColumn.bolusCalculatorSettingTable_descriptionRow--rows {
                .bolusCalculatorSettingTable_descriptionRow--rowsTitle {
                    width: 35%;
                    width: 40%;
                }
            }
            &.bolusCalculatorSettingTable--twoColumn {
                .bolusCalculatorSettingTable_descriptionRow--label {
                    /* width: 17.5%; */
                }
                .bolusCalculatorSettingTable_descriptionRow--content {
                    /* width: 82.5%; */
                }
            }
        }
    }
    
    .bolusCalculatorSettingTable-24ctn {
        margin-top: calc(10 / 16) * 1rem;
        .bolusCalculatorSettingTable-24ctn_oneVerticalCtn {
            width: 26.66666666666667%;
            &.bolusCalculatorSettingTable-24ctn_oneVerticalCtn--wider {
                width: 36.66666666666667%;
                .bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow .bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--ctn {
                    text-align: left;
                    text-indent: 0.4em;
                    
                }
            }
            .bolusCalculatorSettingTable-24ctn_oneVerticalCtn--title {
                @include bBox();
                background-color: $colorGluMesurementLabelBg;
                color: $colorGluMesurementFont;
                padding: 0 calc(5 / 16) * 1rem;
                text-indent: 0; 
                height: 100%;
                min-height: 40px;
                @include flexColumn(center, center);
                border-radius: 4px;
                margin-bottom: calc(10 / 16) * 1rem;
                font-weight: bold;
            }
            .bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow {
                $h: 26px;
                $r: 4px;
                font-weight: normal;
                border-bottom: 0.5px solid $colorEchartStripeInnerBorder;
                > * {
                    display: inline-block;
                    vertical-align: middle;
                }
                .bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--label {
                    color: rgba(0, 0, 0, 1);
                    font-size: 1em;
                    font-weight: 600;
                    width: 50%;
                    text-align: left;
                    @include heightMiddle($h);
                }
                .bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--ctn {
                    background-color: $colorGluMesurementLabelBg;
                    color: $colorGluMesurementFont;
                    width: 50%;
                    @include heightMiddle($h);
                    text-align: center;
                    > div {
                        @include flexRow(center, center);
                        word-wrap: break-word;
                        word-break: normal;
                        line-height: initial;
                        width: 100%;
                        height: 100%;
                        @include bBox();
                    }
                    .ctn-unit {
                        /* margin-left: 0.4em; */
                    }
                }

                &.bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--first {
                    .bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--ctn {
                        border-top-left-radius: $r;
                        border-top-right-radius: $r;
                    }
                }
                &.bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--last {
                    border-bottom-right-radius: $r;
                    .bolusCalculatorSettingTable-24ctn_oneVerticalContent-oneRow--ctn {
                        border-bottom-left-radius: $r;
                        border-bottom-right-radius: $r;
                    }
                }
            }
        }

        @include flexRow(space-between);
    }
}
</style>
